export default function About() {
  return (
    <section id="about" className="relative py-32 bg-gradient-to-b from-[#3D2817] to-[#2A1810]">
      <div className="max-w-7xl mx-auto px-8">
        <div className="mb-8">
          <span className="inline-block px-5 py-2 bg-[#E8DFF5] text-[#5B21B6] text-xs font-semibold uppercase tracking-wider rounded-full">
            // ABOUT US
          </span>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl font-bold text-white mb-8 leading-tight">
              Building Excellence in iOS Development
            </h2>
            
            <p className="text-lg text-[#F5F1ED]/95 leading-relaxed mb-6">
              BUBA d.o.o. is a dedicated team of experts specializing in modern iOS application development. We combine technical excellence with creative innovation to deliver applications that stand out in the App Store.
            </p>
            
            <p className="text-lg text-[#F5F1ED]/75 leading-relaxed mb-12">
              Our commitment to quality and user experience drives every project we undertake. From concept to deployment, we ensure that each application meets the highest standards of performance, security, and design.
            </p>
          </div>

          <div className="flex justify-center lg:justify-end">
            <div className="w-full max-w-md h-96 bg-[#FAF8F5] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://public.readdy.ai/ai/img_res/b9cb93d9e87c38b4ca229b4ab150347d.jpg"
                alt="iOS Development"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
